import type { LegacyRef } from 'react'
import ReactInputMask, { type Props as ReactInputMaskProps } from 'react-input-mask'

export type InputMaskProps = Omit<ReactInputMaskProps, 'dangerouslySetInnerHTML'>

const InputMask = (props: InputMaskProps) => (
  <ReactInputMask ref={props.inputRef as LegacyRef<ReactInputMask> | undefined} {...props} />
)

export default InputMask
